import { z } from 'zod/v3';

export const healthServiceApiResponseSchema = z.object({
  status: z.string(),
});
export type HealthServiceApiResponse = z.infer<
  typeof healthServiceApiResponseSchema
>;
